/* eslint-disable */
import React from 'react';
import { string } from 'prop-types';

const Trending = ({ className, color }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14 8C14 7.44772 14.4477 7 15 7H22V14.2308C22 14.7831 21.5523 15.2308 21 15.2308C20.4477 15.2308 20 14.7831 20 14.2308V10.4801L14.387 16.309C14.1985 16.5048 13.9384 16.6154 13.6667 16.6154C13.3949 16.6154 13.1349 16.5048 12.9463 16.309L9 12.2109L3.72032 17.6936C3.33723 18.0915 2.70418 18.1034 2.30636 17.7203C1.90854 17.3372 1.89659 16.7042 2.27968 16.3064L8.27968 10.0756C8.46818 9.87983 8.72824 9.76923 9 9.76923C9.27176 9.76923 9.53182 9.87983 9.72032 10.0756L13.6667 14.1737L18.6488 9H15C14.4477 9 14 8.55228 14 8Z" fill={color} />
    </svg>
);

Trending.propTypes = {
    className: string,
    color: string,
};

Trending.defaultProps = {
    className: '',
    color: '#3D02FF',
};

export default Trending;
